function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M51.9,94.2H10.7L4.7,24h52.2L51.9,94.2z M13.5,91.2h35.6L53.6,27H8L13.5,91.2z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "30.6,18.9 27.6,18.9 27.6,2.8 42,2.8 42,5.8 30.6,5.8  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "35.7,17.8 32.7,17.8 32.7,7.7 42,7.7 42,10.7 35.7,10.7  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "89.2,94.2 51.4,94.2 51.4,91.2 86.5,91.2 91.9,49.1 55.3,49.1 55.3,46.1 95.3,46.1  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 63,
  y: 42.5,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 61.7353 -27.8757)",
  width: 3,
  height: 36.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 58,
  y: 44.7,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 56.1063 -26.0478)",
  width: 3,
  height: 20.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 68,
  y: 40,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 67.3767 -29.675)",
  width: 3,
  height: 53
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 72.1,
  y: 45.9,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 73.4023 -30.5462)",
  width: 3,
  height: 54.8
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 76.7,
  y: 61.5,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 79.1836 -32.0065)",
  width: 3,
  height: 36.2
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 81.5,
  y: 76.2,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 84.9311 -33.5491)",
  width: 3,
  height: 19.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 53.6,
  y: 46.5,
  width: 39.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 10.8,
  y: 77.5,
  width: 40.6,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 10.8,
  y: 90.9,
  width: 40.6,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 9.5,
  y: 64.1,
  width: 43.1,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 8.7,
  y: 50.8,
  width: 45.8,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 7,
  y: 37.4,
  width: 49.2,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M79.5,35.8c-0.3-0.7-0.7-1.3-1.2-1.8c-0.5-0.5-1.1-0.9-1.8-1.2c-1.4-0.6-3.1-0.6-4.5,0c-0.7,0.3-1.3,0.7-1.8,1.2 c-0.5,0.5-0.9,1.1-1.2,1.8l-2.8-1.2c0.4-1,1.1-2,1.9-2.8c0.8-0.8,1.7-1.4,2.8-1.9c2.2-0.9,4.7-0.9,6.8,0c1,0.4,2,1.1,2.8,1.9 c0.8,0.8,1.4,1.7,1.9,2.8L79.5,35.8z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M95.1,40.9h-3c0-3.2-2.6-5.8-5.8-5.8s-5.8,2.6-5.8,5.8h-3c0-4.8,3.9-8.8,8.8-8.8S95.1,36,95.1,40.9z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M70.8,40.9h-3c0-3.2-2.6-5.8-5.8-5.8s-5.8,2.6-5.8,5.8h-3c0-4.8,3.9-8.8,8.8-8.8S70.8,36,70.8,40.9z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "99.5,49.1 54.5,49.1 54.5,46.1 96.5,46.1 96.5,41.4 54.5,41.4 54.5,38.4 99.5,38.4  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M59.5,27H1V16.3h58.5V27z M4,24h52.5v-4.7H4V24z"
})))));

var SvgSodaPopcorn = function SvgSodaPopcorn(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/soda-popcorn.394571c7.svg";
export { SvgSodaPopcorn as ReactComponent };